import { UnitOfMeasure } from './MooringSalesOrderLine';

export class PluckingListDto {
  public ArticleId: number;
  public ComponentId: number;
  public ArticleName: string;
  public ArticleNumber: string;

  public ExpectedQuantity: number;
  public PluckedQuantity: number;

  public Certificates: ItemCertificateDto[];
}

export class GridLinePluckingDto {
  public GridLineId: number;
  public MoorlogNo: string;
  public AnalysisNo: string;
  public Articles: PluckingListDto[] = [];
}

export class ItemCertificateDto {
  public CertificateId: number;
  public BatchNumber: string;
  public BatchNumberTo: string;
  public ActualBatchNo: string;
  public Quantity: number;
  public UnitOfMeasure: UnitOfMeasure;
}

export class SetPluckingListDto {
  public ArticleId: number;
  public ComponentId?: number;
  public Certificates: RegisterCertificateDto[] = [];
}

export class RegisterCertificateDto {
  public CertificateId: number;
  public Quantity: number;
  public ActualBatchNo: string = '';
}
